<template lang="html">
  <div class="row notFound">
    <div class="lg-2">

    </div>
    <div class="lg-10 text-right text">
      <h1>404 {{translation.serverError.notFound}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  data(){
    return {
      translation: null
    }

  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  }
}
</script>

<style lang="css" scoped>
.notFound {
  background-image: url('../assets/img/backgrounds/4.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
.notFound .text {
  padding-top: 13em;
  color: #fff;
  font-weight: bold;
  margin-right: 3em;
}
</style>
